import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import PasswordInput from "../components/PasswordInput";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      if (user) { try { await logout(); } catch { /* ignore */ } }
      toast.success("Password aggiornata · accedi con la nuova password");
      nav("/login", { replace: true });
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Errore, riprova"); }
    finally { setLoading(false); }
  };
  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="ga-card p-8" data-testid="reset-card">
        <div className="text-xs font-mono uppercase tracking-widest text-slate-500">Recupero accesso</div>
        <h1 className="mt-1 font-display text-3xl font-extrabold text-slate-900">Nuova password</h1>
        {user && <div className="mt-3 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-2" data-testid="reset-logged-in-notice">Sei già collegato come <b>{user.email}</b>: al salvataggio verrai disconnesso e potrai accedere con la nuova password.</div>}
        {!token ? (
          <div className="mt-6 text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl p-4" data-testid="reset-missing-token">Link non valido. <Link to="/password-dimenticata" className="underline font-semibold">Richiedi un nuovo reset</Link>.</div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="password">Nuova password (min 6 caratteri)</Label>
              <PasswordInput id="password" required minLength={6} value={password} onChange={e => setPassword(e.target.value)} testId="reset-password-input" autoComplete="new-password" />
            </div>
            <div>
              <Label htmlFor="confirm">Conferma password</Label>
              <PasswordInput id="confirm" required minLength={6} value={confirm} onChange={e => setConfirm(e.target.value)} testId="reset-confirm-input" autoComplete="new-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full ga-btn-primary rounded-full" data-testid="reset-submit-button">{loading ? "Salvataggio..." : "Salva nuova password"}</Button>
          </form>
        )}
        <p className="mt-6 text-sm text-slate-600"><Link to="/login" className="font-semibold text-slate-900 hover:underline">← Torna al login</Link></p>
      </div>
    </div>
  );
}
